import { render, staticRenderFns } from "./--absoluteform.vue?vue&type=template&id=b9c25028"
import script from "./--absoluteform.vue?vue&type=script&lang=js"
export * from "./--absoluteform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports